export const CompanyDataRowSkeleton = () => <div className={"h-3.5 w-full animate-pulse rounded-lg bg-gray-300"} />;

const CompanyDataRowSkeletons = ({ count = 1 }: { count?: number }) => (
  <div className={"grid gap-2"}>
    {Array.from({ length: count }).map((_, index) => (
      <CompanyDataRowSkeleton key={index} />
    ))}
  </div>
);

export default CompanyDataRowSkeletons;
